/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportFilters_viewer = {|
  +roles: ?$ReadOnlyArray<?string>;
  +devices: ?$ReadOnlyArray<?{|
    +id: string;
    +tags: ?$ReadOnlyArray<?string>;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportFilters_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "roles",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DevicePicker_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TagPicker_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Device",
      "name": "devices",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tags",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/__generated__/ReportFilters_viewer.graphql.js